import { ApiService } from '../../app-lite/api/api.service';

import ApplyVendorCreditsHtml from './vendor-credit.apply.html';

export function VendorCreditsStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller: 'applyVendorCreditsCtrl',
    name      : 'app.apply-vendor-credits',
    params    : {
      id: { squash: true, value: null }
    },
    templateUrl: ApplyVendorCreditsHtml,
    url        : '/:vendor_id/apply_vendor_credit/:id',
    resolve    : {
      credit: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string => $stateParams.id
        ? workshopAPI.get('/vendor_invoice', $stateParams.id)
        : '',
      credits: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/vendors/invoice_list', [
        $stateParams.vendor_id, 0, 6, 'P', 'C', '*', '*', '*', 'desc', 'post_date'
      ]),
      vendor: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/vendor', $stateParams.vendor_id)
    }
  });
}